/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const UsersIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => (
  <svg
    className={classNames(className)}
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      id="Vector"
      d="M19.1668 15.8335C19.1668 16.0545 19.079 16.2665 18.9228 16.4227C18.7665 16.579 18.5545 16.6668 18.3335 16.6668H8.3335C8.11249 16.6668 7.90052 16.579 7.74424 16.4227C7.58796 16.2665 7.50017 16.0545 7.50017 15.8335C7.50017 14.5074 8.02695 13.2356 8.96463 12.298C9.90232 11.3603 11.1741 10.8335 12.5002 10.8335H14.1668C15.4929 10.8335 16.7647 11.3603 17.7024 12.298C18.6401 13.2356 19.1668 14.5074 19.1668 15.8335ZM13.3335 3.3335C12.6742 3.3335 12.0298 3.52899 11.4816 3.89526C10.9334 4.26153 10.5062 4.78213 10.2539 5.39122C10.0016 6.0003 9.9356 6.67052 10.0642 7.31713C10.1928 7.96373 10.5103 8.55767 10.9765 9.02385C11.4427 9.49002 12.0366 9.80749 12.6832 9.93611C13.3298 10.0647 14 9.99871 14.6091 9.74642C15.2182 9.49413 15.7388 9.06689 16.1051 8.51873C16.4713 7.97056 16.6668 7.3261 16.6668 6.66683C16.6668 5.78277 16.3156 4.93493 15.6905 4.30981C15.0654 3.68469 14.2176 3.3335 13.3335 3.3335ZM5.8335 3.3335C5.17423 3.3335 4.52976 3.52899 3.9816 3.89526C3.43343 4.26153 3.00619 4.78213 2.7539 5.39122C2.50161 6.0003 2.4356 6.67052 2.56421 7.31713C2.69283 7.96373 3.0103 8.55767 3.47647 9.02385C3.94265 9.49002 4.53659 9.80749 5.1832 9.93611C5.8298 10.0647 6.50002 9.99871 7.10911 9.74642C7.7182 9.49413 8.23879 9.06689 8.60507 8.51873C8.97134 7.97056 9.16683 7.3261 9.16683 6.66683C9.16683 5.78277 8.81564 4.93493 8.19052 4.30981C7.5654 3.68469 6.71755 3.3335 5.8335 3.3335ZM5.8335 15.8335C5.83226 14.9582 6.00471 14.0913 6.34087 13.2831C6.67702 12.4749 7.1702 11.7414 7.79183 11.1252C7.28311 10.9331 6.74394 10.8343 6.20017 10.8335H5.46683C4.23867 10.8357 3.06144 11.3246 2.193 12.193C1.32456 13.0614 0.835699 14.2387 0.833496 15.4668V15.8335C0.833496 16.0545 0.921293 16.2665 1.07757 16.4227C1.23385 16.579 1.44582 16.6668 1.66683 16.6668H5.9835C5.88648 16.3996 5.83575 16.1178 5.8335 15.8335Z"
      fill={color}
    />
  </svg>
);
